// @ts-check
export class Widget {
/**
 * 
 * @param {any} main 
 * @param {any} parent
 */
constructor(main,parent){
this.m = this.main = main;
this.parent = parent;
this.isView = false;
}//

async getRecentPostsWidget2(data={},){
let {type='new',v=this.m.pb.ep.recentPosts.data,dClass=[]} = data;
v = {...this.m.pb.ep.recentPosts.data,...v};
let $this = this;
let displayPosts;
if(v.items){
displayPosts = v.items;
}else{
displayPosts = await this.m.fu.fetch({
  link:this.m.fu.getApi(`/home/posts/post/${v.cat}`,[{n:'limit',v:v.l}])
});
}
//exclude current post
if(v.currentPost){
displayPosts = displayPosts.filter(p=>p.id!=v.currentPost.id);
}
let r =await this.parent.pb.getBlockContainer({name:'recentPosts',main:'div',clasz:['container'],cmCallback:attachEvents});
r.el.removeAttribute('contenteditable');
let row,column;
row = this.m.pbu.createElement('div',['row','sp-row','g-4','justify-content-center']);//'align-items-stretch'
r.el.appendChild(row);
if(displayPosts.length>0){
for(let p of displayPosts){
let url = this.m.getHomeLink('post',p.postType,'s',p.title,p.id);
column = this.m.pbu.createElement('div');
if(v.isSidebar){
  this.m.pbu.addClass(column,['col-12']);
}else{
  this.m.pbu.addClass(column,['col-md-5','mx-2']);
}
row.appendChild(column);
column.innerHTML = 
`
<article class="card post-card h-100">
<a href="${url}" class="sp-route-link sp-detail ${this.m.pbu.showIf(v.wi)}"><img ${this.m.pbu.setAttributeIf(p.featuredImageUrl,[{n:"src",v:p.featuredImageUrl}])} class="card-img-top"></a>

<!-- meta -->
<div class="card-body d-flex flex-column">

  
  <div class="post-meta ${this.main.pbu.showIf(p.category)}">
    <a href="${this.m.getHomeLink('category','post','postcategory',p.category?.title,p.category?.id)}" class="sp-route-link sp-detail text-decoration-none badge sp-subtle text-secondary-emphasis">${p.category?.title}</a>
  </div>


  <a href="${url}" class="sp-route-link sp-detail text-decoration-none"><h3 sh="1" class="card-title sp-h">${p.title}</h3></a>

  <!-- Excerpt -->
  <p class="card-text ${this.m.pbu.showIf(v.we)}">${(p.excerpt)?p.excerpt.substring(0, 120) + '...':''}</p>

  <a href="${url}" class="sp-route-link sp-detail btn btn-primary mt-auto align-self-center">
    Read more ${await this.main.pbu.getSvg('arrow-right')}
  </a>
</div>
</article>
`       
if(!p.featuredImageUrl && v.wi){
let image = column.querySelector('img');
/**@type {HTMLDivElement}*/let defaultDiv = this.m.pbu.createElement('div',['sp-subtle','h-100']);
defaultDiv.style.minHeight = '200px';
this.m.pbu.replaceChild(image,defaultDiv);
}
}//for
}else{
this.m.pbu.replace(r.el,'<p>No post found</p>');
}

this.m.pb.restoreAttributes('recentPosts',r.el,v);
if(this.isView){

}else{
attachEvents(null);
}

return r.bc;

/**
 * 
 * @param {boolean|null} save 
 */
async function attachEvents(save){
if(save==null){

}

if(save==false){
let rpwTemplate = await $this.getTemplate('recentPosts',v);
return rpwTemplate.div;
}

if(save==true){
let otherSettings = r.cMenu.otherSettings;
let cat = otherSettings.querySelector('select.cat').value;
v = {
    l:Number(otherSettings.querySelector('select.l').value),
    cat:$this.m.utils.isNull(cat)?-1:cat,
    we:otherSettings.querySelector('input.we').checked,
    wi:otherSettings.querySelector('input.wi').checked,
    wm:otherSettings.querySelector('input.wm').checked,
    items:displayPosts
  }
  
  let bc = await $this.getRecentPostsWidget({v:v});
  $this.m.pbu.replace(r.el,bc.querySelector('[m]').innerHTML);
  //update attribute to enable saving
  r.el.setAttribute('l',v.l);
  r.el.setAttribute('cat',v.cat);
  r.el.setAttribute('we',v.we);
  r.el.setAttribute('wi',v.wi);
  r.el.setAttribute('wm',v.wm);
  //
  return true;
}
}//inner

}//func

async getRecentPostsWidget(data={},){
let {type='new',v=this.m.pb.ep.recentPosts.data,dClass=[]} = data;
v = {...this.m.pb.ep.recentPosts.data,...v};
let $this = this;
let displayPosts;
if(v.items){
displayPosts = v.items;
}else{
displayPosts = await this.m.fu.fetch({
  link:this.m.fu.getApi(`/home/posts/post/${v.cat}`,[{n:'limit',v:v.l}])
});
}
//exclude current post
if(v.currentPost){
displayPosts = displayPosts.filter(p=>p.id!=v.currentPost.id);
}
let r =await this.parent.pb.getBlockContainer({name:'recentPosts',main:'div',clasz:['container'],cmCallback:attachEvents});
r.el.removeAttribute('contenteditable');
let row,column;
row = this.m.pbu.createElement('div',['row','sp-row','g-4','justify-content-center']);//'align-items-stretch'
r.el.appendChild(row);
if(displayPosts.length>0){
for(let p of displayPosts){
let url = this.m.getHomeLink('post',p.postType,'s',p.title,p.id);
column = this.m.pbu.createElement('div');
if(v.isSidebar){
  this.m.pbu.addClass(column,['col-12']);
}else{
  this.m.pbu.addClass(column,['col-md-5','mx-2']);
}
row.appendChild(column);
column.innerHTML = 
`
<article class="card post-card h-100">
<a href="${url}" class="${this.m.addRouteClass()} ${this.m.pbu.showIf(v.wi)}"><img ${this.m.pbu.setAttributeIf(p.featuredImageUrl,[{n:"src",v:p.featuredImageUrl}])} class="card-img-top"/></a>

<!-- meta -->
<div class="card-body d-flex flex-column">

  
  <div class="post-meta ${this.main.pbu.showIf(p.category)}">
    <a href="${this.m.getHomeLink('category','post','postcategory',p.category?.title,p.category?.id)}" class="${this.m.addRouteClass()} text-decoration-none badge sp-subtle text-secondary-emphasis">${p.category?.title}</a>
  </div>


  <a href="${url}" class="${this.m.addRouteClass()} text-decoration-none"><h3 sh="1" class="card-title sp-h">${p.title}</h3></a>

  <!-- Excerpt -->
  <p class="card-text ${this.m.pbu.showIf(v.we)}">${(p.excerpt)?p.excerpt.substring(0, 120) + '...':''}</p>

  <a href="${url}" class="${this.m.addRouteClass()} btn btn-primary mt-auto align-self-center">
    Read more ${await this.main.pbu.getSvg('arrow-right')}
  </a>
</div>
</article>
`       
if(!p.featuredImageUrl && v.wi){
let image = column.querySelector('img');
/**@type {HTMLDivElement}*/let defaultDiv = this.m.pbu.createElement('div',['sp-subtle','h-100']);
defaultDiv.style.minHeight = '200px';
this.m.pbu.replaceChild(image,defaultDiv);
}
}//for
}else{
this.m.pbu.replace(r.el,'<p>No post found</p>');
}

this.m.pb.restoreAttributes('recentPosts',r.el,v);
if(this.isView){

}else{
attachEvents(null);
}

return r.bc;

/**
 * 
 * @param {boolean|null} save 
 */
async function attachEvents(save){
if(save==null){

}

if(save==false){
let rpwTemplate = await $this.getTemplate('recentPosts',v);
return rpwTemplate.div;
}

if(save==true){
let otherSettings = r.cMenu.otherSettings;
let cat = otherSettings.querySelector('select.cat').value;
v = {
    l:Number(otherSettings.querySelector('select.l').value),
    cat:$this.m.utils.isNull(cat)?-1:cat,
    we:otherSettings.querySelector('input.we').checked,
    wi:otherSettings.querySelector('input.wi').checked,
    wm:otherSettings.querySelector('input.wm').checked,
    items:displayPosts
  }
  
  let bc = await $this.getRecentPostsWidget({v:v});
  $this.m.pbu.replace(r.el,bc.querySelector('[m]').innerHTML);
  //update attribute to enable saving
  r.el.setAttribute('l',v.l);
  r.el.setAttribute('cat',v.cat);
  r.el.setAttribute('we',v.we);
  r.el.setAttribute('wi',v.wi);
  r.el.setAttribute('wm',v.wm);
  //
  return true;
}
}//inner

}//func


/**
 * @param {string} name 
 * @param {any} data 
 */
async getTemplate(name,data){
  switch(name){
    case 'recentPosts':
    let div = this.m.pbu.createElement('div',['m-2','p-2']);
  div.innerHTML = 
  `
<form>
  ${this.m.pbu.createSelectElement({serialize:true,title:'Limit',value:data.l,items:['1','2','3','4','6','8','9','12'],clasz:['l','recent-posts-limit']})}
  ${this.m.pbu.createSelectElement({serialize:true,title:'Category',value:data.cat,default:'All',postItems:[...this.parent.categories$],clasz:['cat','recent-posts-category']})}
  ${this.m.pbu.createFormControl({serialize:true,title:"Show Image",value:data.wi,type:'checkbox',clasz:['wi','recent-posts-with-image']})}
   ${this.m.pbu.createFormControl({serialize:true,title:"Show Excerpt",value:data.we,type:'checkbox',clasz:['we','recent-posts-with-excerpt']})}
   ${this.m.pbu.createFormControl({serialize:true,title:"Show Meta",value:data.wm,type:'checkbox',clasz:['wm','recent-posts-with-meta']})}
  <button type="button" class="sp-save d-none">Save</button>
</form>
  `;
  let l = div.querySelector('select.l');
  let cat = div.querySelector('div.category select');
  let wi = div.querySelector('input.wi');
  let we = div.querySelector('input.we');
  let wm = div.querySelector('input.wm');
  let saveButton = div.querySelector('button.sp-save');
  let template ={
    div:div,
    cat:cat,
    l:l,
    wi:wi,
    we:we,
    wm:wm,
    saveButton:saveButton
  };
  return template;
  }

}//func
}